import { createSelector } from '@reduxjs/toolkit';

import { NavigationPanelTab } from '../../components/interface/panels/navigation-panel/NavigationPanel';
import { isLayoutViewActive } from './layoutModeSelectors';

export const getNavigationPanelSelectedTab = createSelector(
  isLayoutViewActive,
  (layoutViewActive): NavigationPanelTab => {
    return layoutViewActive ? 'layout' : 'component';
  },
);
